import { Component, h, Prop, Element } from '@stencil/core';
import { validProductPrice, sendEvent } from '../../utils/utils';
import { environment } from '../../global/resources';

@Component({
  tag: 'mo-banner',
  styleUrl: 'mo-banner.css',
  shadow: true,
})
export class BannerFull {
  @Element() el: HTMLElement;
  @Prop() moClientId!: string;
  @Prop() productPrice?: string;
  public urlBase: string = environment.base_url;
  componentDidLoad() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sendEvent('banner', 'view');
          observer.unobserve(entry.target);
        }
      });
    }, options);
    observer.observe(this.el);
  }
  render() {
    return (
      <div class='mo-banner'>
        <div class='container'>
          <div class='mo-banner__information'>
            <div class='offer-name'>
              <img
                src={`${this.urlBase}/assets/powerpay_white.svg`}
                alt='Powerpay Logo'
              />
            </div>
            <div class='offer-description'>
              <p>Paga en cuotas <b>sin intereses</b> con <b>todas las tarjetas de crédito</b> y <b>sin tomar toda tu línea.</b></p>
            </div>
          </div>
          <div class='mo-banner__button'>
            <mo-button
              buttonType='banner'
              price={this.productPrice}
              clientId={this.moClientId}
              offerByPrice={validProductPrice(this.productPrice)}
              gtagCategory='banner'
              valueText='Más información'
            ></mo-button>
          </div>
        </div>
      </div>
    );
  }
}
